import axiosClient from './axiosClient';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import {
  IQueryGetSupportRequests,
  ISupportRequest,
  SupportRequestStatus,
} from '~/utils/interface/supportRequest';

const urlApiSupportRequest = 'support-requests';

const supportRequestApi = {
  getSupportRequests(params?: IQueryGetSupportRequests) {
    return axiosClient.get<IBaseResponse<IListDataResponse<ISupportRequest[]>>>(
      urlApiSupportRequest,
      { params }
    );
  },
  updateStatus(id: number, status: SupportRequestStatus) {
    return axiosClient.patch<IBaseResponse<ISupportRequest>>(
      `${urlApiSupportRequest}/${id}/status`,
      { status }
    );
  },
};

export default supportRequestApi;
